import React from 'react'
import { Col, Row } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';

// icons ----------------------------------
import { FaCircleInfo } from "react-icons/fa6";
import { FaLock } from "react-icons/fa";
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import { FaCalendarAlt } from "react-icons/fa";
import { FaUserShield } from "react-icons/fa6";
import { FaShieldAlt } from "react-icons/fa";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { FaCircleCheck } from "react-icons/fa6";


const AuditSettings = () => {

  const now = 24

  return (
    <div className='audit-settings'>
      <div className='compliance-notice'>
        <span className='first-icon'><FaCircleInfo className='icon' /></span>
        <div>
          <h3 className='color-white font-weight-200'>Compliance Notice</h3>
          <p className='color-white font-weight-200 mt-2'>These audit settings ensure compliance with data protection regulations and internal security policies. Changes to tamper-proof mode and retention periods may require administrator approval.</p>
        </div>
        <div className='last-icons'>
          <div className='first-icon-box'>
            <FaLock /> Secure
          </div>
          <LuSquareArrowOutUpRight className='exit' />
        </div>
      </div>


      <Row className=''>
        <Col sm="6" className='mt-4'>
          <div className='setting-border'>
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <FaCalendarAlt className='clndr-icon' /> Data Retention Period </h3>
              <span className='color-gray font-14 font-weight-200'>Fomrs & Logos</span>
            </div>
            <div className='p-4'>
              <h4 className='color-gray font-weight-200'>Choose how long to keep Form 12BB submissions and audit logs</h4>

              <Row>
                <Col sm="6" className='mt-3'>
                  <div className='Data-Retention-Period-col active'>
                    <h3>1</h3>
                    <p>Year</p>
                    <p>Standard</p>
                  </div>
                </Col>

                <Col sm="6" className='mt-3'>
                  <div className='Data-Retention-Period-col'>
                    <h3>1</h3>
                    <p>Year</p>
                    <p>Standard</p>
                  </div>
                </Col>

                <Col sm="6" className='mt-3'>
                  <div className='Data-Retention-Period-col'>
                    <h3>1</h3>
                    <p>Year</p>
                    <p>Standard</p>
                  </div>
                </Col>

                <Col sm="6" className='mt-3'>
                  <div className='Data-Retention-Period-col'>
                    <h3>1</h3>
                    <p>Year</p>
                    <p>Standard</p>
                  </div>
                </Col>
              </Row>

              <hr className='color-gray mt-4' />

              <div>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div>
                    <h3 className='color-white font-weight-200'>Current Storage Usage</h3>
                    <h5 className='color-gray font-weight-200 mt-1'>2.4 GB of 10 GB allocated</h5>
                  </div>

                  <div>
                    <h3 className='percentage-purple'>24%</h3>
                    <h5 className='color-gray font-12 font-weight-200 mt-1'>Used</h5>
                  </div>
                </div>
                <ProgressBar now={now} label={`${now}%`} visuallyHidden className='custom-bar mt-3' />
              </div>
            </div>

          </div>
        </Col>
        <Col sm="6" className='mt-4'>
          <div className='setting-border'>
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <FaUserShield className='clndr-icon' /> Access Control</h3>
              <span className='color-gray font-14 font-weight-200'>Permissions</span>
            </div>
          </div>
        </Col>
        <Col sm="6" className='mt-4'>
          <div className='setting-border'>
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <FaShieldAlt className='clndr-icon' /> Security & Integrity</h3>
              <span className='secure font-14 '><FaCheck /> Secure</span>
            </div>
          </div>
        </Col>
        <Col sm="6" className='mt-4'>
          <div className='setting-border'>
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <FaCloudUploadAlt className='clndr-icon' />Backup Settings </h3>
              <span className='active font-14 '><FaCircleCheck /> Active</span>
            </div>
          </div>
        </Col>
      </Row>



    </div>
  )
}

export default AuditSettings